"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const api_1 = require("@/api");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const _1 = require(".");
function default_1({ open, closeDialog, onSelectGooglePlace, maxWidth768, }) {
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog, dialogName: 'search-google-place' });
    (0, functions_1.useIOSDialogCloseScrollBack)(open);
    const [searchList, setSearchList] = (0, react_1.useState)([]);
    const resetSearchList = () => setSearchList([]);
    const [isSearching, setIsSearching] = (0, react_1.useState)(false);
    const onSearchRequest = (keyword) => __awaiter(this, void 0, void 0, function* () {
        if (!isSearching) {
            if (keyword) {
                setIsSearching(true);
                yield (0, api_1.getData)(`/member/search/address?search_text=${keyword}`)
                    .then(res => {
                    const searchResultArr = res.data.data.results;
                    if (searchResultArr.length) {
                        const parsedResultArr = searchResultArr.map((item) => {
                            const { name, formatted_address } = item;
                            return { name, formatted_address };
                        });
                        setSearchList(parsedResultArr);
                    }
                    else
                        setSearchList('none');
                })
                    .catch(err => {
                    console.log(err);
                    alert((0, errors_1.commonErrorMsg)());
                })
                    .finally(() => setIsSearching(false));
            }
            else
                resetSearchList();
        }
    });
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: open, onClose: closeDialog, fullScreen: maxWidth768, PaperProps: {
            sx: {
                width: maxWidth768 ? '100%' : '430px',
                height: maxWidth768 ? '100%' : '60vh',
                borderRadius: 0,
                margin: 0,
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(_1.SearchAddressHeader, { closeDialog: closeDialog }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '11px 34px 11px 16px',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.8)',
                } }, { children: [(0, jsx_runtime_1.jsx)("input", { css: { width: '100%', fontSize: '14px' }, placeholder: t('검색어를 입력해주세요'), onKeyDown: e => {
                            if (e.key === 'Enter')
                                onSearchRequest(e.currentTarget.value);
                            if (e.key === 'Escape') {
                                e.currentTarget.value = '';
                                resetSearchList();
                            }
                        } }), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: { position: 'absolute', right: '12px' }, onClick: e => {
                            const keyword = e.currentTarget.previousElementSibling.value;
                            onSearchRequest(keyword);
                        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.SearchIconSvg, { css: { width: '16px', height: '16px' } }) }))] })), searchList === 'none' ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { padding: '3px 16px', fontSize: '13px', color: '#eb5757' } }, { children: `${t('검색 결과가 없어요.')} ${t('다시 검색해주세요!')}` }))) : isSearching ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { margin: '100px auto', color: 'rgba(0, 0, 0, 0.1)' } }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "inherit", thickness: 6 }) }))) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { paddingBottom: '80px', overflowY: 'auto' } }, { children: searchList.map((list, index) => ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ onClick: () => onSelectGooglePlace(list.formatted_address), sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        rowGap: '2px',
                        padding: '11px 16px',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                        '> *': { whiteSpace: 'pre-wrap' },
                        div: {
                            lineHeight: '22px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: 'rgba(0, 0, 0, 0.7)',
                        },
                        span: {
                            lineHeight: '20px',
                            fontSize: '13px',
                            color: 'rgba(0, 0, 0, 0.4)',
                        },
                    } }, { children: [(0, jsx_runtime_1.jsx)("div", { children: list.name }), (0, jsx_runtime_1.jsx)("span", { children: list.formatted_address })] }), `google_place_search_list_${index}_${list.name}`))) })))] })));
}
exports.default = default_1;
